const STACKED_SLIDER_ROLE_CLASSES = ['is-center', 'is-left-1', 'is-left-2', 'is-right-1', 'is-right-2', 'is-hidden-left', 'is-hidden-right'];

function stackedSliderShortestDistance(from, to, total) {
    let diff = (to - from) % total;
    if (diff > total / 2) diff -= total;
    if (diff < -total / 2) diff += total;
    return diff;
}

function stackedSliderRoleForDistance(distance) {
    if (distance === 0) return 'is-center';
    if (distance === 1) return 'is-right-1';
    if (distance === -1) return 'is-left-1';
    if (distance === 2) return 'is-right-2';
    if (distance === -2) return 'is-left-2';
    return distance > 0 ? 'is-hidden-right' : 'is-hidden-left';
}

function initStackedCardSlider(root) {
    const cards = Array.from(root.querySelectorAll('[data-slider-card]'));
    const dots = Array.from(root.querySelectorAll('[data-slider-dot]'));
    const count = cards.length;

    if (!count) return;

    const autoplayMs = parseInt(root.getAttribute('data-autoplay-ms'), 10) || 5000;
    let activeIndex = 0;
    let autoplayTimer;

    function render() {
        cards.forEach((card, i) => {
            const distance = count > 1 ? stackedSliderShortestDistance(activeIndex, i, count) : 0;
            card.classList.remove(...STACKED_SLIDER_ROLE_CLASSES);
            card.classList.add(stackedSliderRoleForDistance(distance));
            card.setAttribute('aria-hidden', distance === 0 ? 'false' : 'true');
        });

        dots.forEach((dot, i) => {
            dot.classList.toggle('is-active', i === activeIndex);
            dot.setAttribute('aria-current', i === activeIndex ? 'true' : 'false');
        });
    }

    function goTo(index) {
        activeIndex = ((index % count) + count) % count;
        render();
    }

    function restartAutoplay() {
        clearInterval(autoplayTimer);
        if (count > 1) {
            autoplayTimer = setInterval(() => goTo(activeIndex + 1), autoplayMs);
        }
    }

    dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
            goTo(i);
            restartAutoplay();
        });
    });

    cards.forEach((card, i) => {
        card.addEventListener('click', (event) => {
            if (i !== activeIndex) {
                event.preventDefault();
                goTo(i);
                restartAutoplay();
            }
        });
    });

    render();
    restartAutoplay();
}

document.querySelectorAll('[data-stacked-slider]').forEach(initStackedCardSlider);
